<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="caja-operacion?status={{status}}" titulo="Caja"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

      <!-- Menu izquierda del modulo enviroment" -->
      <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:1em;">
      <div style="background: #FFF; border-radius: 1em; ">

        <!-- Opciones y busqueda -->
        <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>
        <div class="field">
          <div class="b-checkbox is-info is-circular">
            <input type="radio" id="status1" class="styled" name="status" value="1" [(ngModel)]="status">
            <label for="status1">
              Abiertas
            </label>

            <input type="radio" id="status2" class="styled" name="status" value="0" [(ngModel)]="status">
            <label for="status2">
              Cerradas
            </label>
          </div>

        </div>
        <span id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block;" [style.height.px]="ctrl.tamano-218">

          <!--Tabla -->
          <table class="table is-striped  is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando">
            <thead>
              <tr>
                <th><abbr>ID</abbr></th>
                <th>Caja</th>
                <th>Fecha apertura</th>
                <th>Provisión Inicial</th>
                <th>Abierto por</th>
                <th width="1%" class="no_pdf">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of ctrl.dato; let i=index">
                <th style="vertical-align: middle;">{{ item.id }}</th>
                <td style="vertical-align: middle;">{{ item.cajas.nombre }} </td>
                <td style="vertical-align: middle;">{{ item.fecha_apertura }} </td>
                <td style="vertical-align: middle;">{{ item.provision_inicial }} </td>
                <td style="vertical-align: middle;">{{ item.abrio ? item.abrio.nombre : '' }} </td>
                <td style="vertical-align: middle;" class="has-text-centered no_pdf">
                  <!-- acciones -->
                  <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                </td>

              </tr>
              <tr *ngIf="ctrl.dato.length == 0">
                <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
              </tr>
            </tbody>

          </table>

          <!--Lista -->
          <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando" class="lista_lista">
            <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
              <article class="media">
                <div class="media-left">
                  <figure class="image is-64x64">
                    <img src="./assets/128x128.png" alt="Image">
                  </figure>
                </div>
                <div class="media-content">
                  <div class="content">
                    <p>
                      <strong style="font-size:12pt">{{ item.cajas.nombre }}</strong> <small><span class="icon"><i class="fa fa-user"></i></span>
                        &nbsp; Abierto por: {{ item.abrio ? item.abrio.nombre : ''}}</small>
                    </p>
                    <strong class="tag is-success is-medium"><i class="fa fa-money"></i>&nbsp; Provisión Inicial: $ {{
                      item.provision_inicial }}</strong>
                    <strong class="tag is-dark is-medium"><i class="fa fa-calendar"></i>&nbsp; Fecha apertura:
                      {{item.fecha_apertura}}</strong>
                  </div>
                  <nav class="level is-mobile" style="float:right">
                    <div class="level-left">

                      <!-- acciones -->
                      <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                    </div>
                  </nav>
                </div>
              </article>
            </div>
          </span>
        </span>
        <!-- Paginación para la lista  -->
        <app-paginacion [ctrl]="ctrl"></app-paginacion>
      </div>

    </div>
    </div>

    <div class="box" id="imprimir" *ngIf="ctrl.json">
      <div class="box-header">
        <p align="center" id="datos">
          <strong>{{ctrl.configuracion.empresa.nombre}}</strong>
          <br> {{ctrl.configuracion.empresa.direccion}}
          <br> Tel: {{ctrl.configuracion.empresa.telefono}}
          <br>
          <br>
          <strong> Suc: {{ctrl.configuracion.sucursal.nombre}}</strong>
          <br> {{ctrl.configuracion.sucursal.direccion}}
        </p>
        <br>
        <h2 align="center" style="font-size: 2em;">CORTE DE CAJA</h2>
      </div>
      <!-- resumen -->
      <div class="media-content">
        <div class="content">

          <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center">
            <tbody>
              <tr>
                <td width="25%">
                  <strong>Fecha Apertura: </strong>
                </td>
                <td width="25%">
                  {{ ctrl.json.fecha_apertura }}
                </td>
                <td width="25%">
                  <strong>Fecha Cierre: </strong>
                </td>
                <td width="25%">
                  {{ ctrl.json.fecha_cierre }}
                </td>
              </tr>
              <tr>
                <td width="25%">
                  <strong>Caja: </strong>
                </td>
                <td colspan="3">
                  {{ ctrl.json.cajas.nombre }}
                </td>
              </tr>
              <tr>
                <td width="25%">
                  <strong>Abierto Por: </strong>
                </td>
                <td colspan="3">
                  {{ ctrl.json.abrio.nombre }}
                </td>
              </tr>
              <tr>
                <td width="25%">
                  <strong>Cerrado Por: </strong>
                </td>
                <td colspan="3">
                  {{ ctrl.json.cerro.nombre }}
                </td>
              </tr>

              <tr>
                <td colspan="4" align="center">
                  <h4>
                    <strong>Resumen de movimientos </strong>
                  </h4>
                </td>
              </tr>
              <tr *ngIf="ctrl.json.pagos_entradas.length > 0">
                <td colspan="4">
                  <h5>Entradas</h5>
                  <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center" style="color:red">
                    <tbody *ngFor=" let item of ctrl.json.pagos_entradas; let i = index">
                      <tr *ngIf="item.nombre != ''">
                        <td align="right" width="24.8%">
                          <strong>{{item.nombre}}</strong>
                        </td>
                        <td>
                          {{item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                        </td>
                        <td width="20%">{{item.tipo}}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr *ngIf="ctrl.json.pagos_salidas.length > 0">
                <td colspan="4">
                  <h5>Salidas</h5>
                  <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center">
                    <tbody *ngFor=" let item of ctrl.json.pagos_salidas; let i = index">
                      <tr *ngIf="item.nombre != ''">
                        <td align="right" width="24.8%">
                          <strong>{{item.nombre}}</strong>
                        </td>
                        <td>
                          {{item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                        </td>
                        <td width="20%">{{item.tipo}}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr *ngIf="ctrl.json.pagos_salidas.length > 0">
                <td colspan="4" align="center">
                  <table class="table is-striped  is-fullwidth" width="100%" border="1" align="center">
                    <tbody>
                      <tr>
                        <td align="right" width="24.8%">
                          <strong>Total Movimientos: </strong>
                        </td>
                        <td>
                          {{ctrl.json.importe_cierre | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                        </td>
                      </tr>
                      <tr>
                        <td align="right">
                          <strong>F.E. Entrada: </strong>
                        </td>
                        <td *ngIf="ctrl.json.flujos_agrupados">
                          {{(ctrl.json.flujos_agrupados.length > 1 ? ctrl.json.flujos_agrupados[1].total : 0) |
                          currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                        </td>
                      </tr>
                      <tr>
                        <td align="right">
                          <strong style="color:red">F.E. Salidad: </strong>
                        </td>
                        <td style="color:red" *ngIf="ctrl.json.flujos_agrupados">
                          {{(ctrl.json.flujos_agrupados.length > 0 ? ctrl.json.flujos_agrupados[0].total : 0) |
                          currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                        </td>
                      </tr>
                      <tr>
                        <td align="right">
                          <strong>Provisión Inicial: </strong>
                        </td>
                        <td *ngIf="ctrl.json.flujos_agrupados">
                          {{ctrl.json.provision_inicial | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                        </td>
                      </tr>
                      <tr>
                        <td align="right">
                          <h4>
                            <strong>Total en Caja: </strong>
                          </h4>
                        </td>
                        <td>
                          <h4>
                            {{((ctrl.json.venta_total * 1) + (ctrl.json.provision_inicial *1)) |
                            currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                          </h4>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <div id="firma" align="center">
            <br>
            <br>
            <br>
            <hr align="center" style="border:#333 solid 2px; width:50%; "> Firma de quien entrega
          </div>
        </div>
      </div>
      <!-- fin resumen -->
    </div>
